import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  couponList: [],
  isLoading: true,
  isDetailLoading: true,
  isExportLoading: true,
};
const couponsSlice = createSlice({
  name: 'Coupons',
  initialState,
  reducers: {
    setCouponList(state, actions) {
      state.couponList = actions.payload;
      state.isLoading = false;
    },
    setCouponDetails(state, actions) {
      state.couponDetail = actions.payload;
      state.isDetailLoading = false;
    },
    setCouponCreate(state, actions) {
      state.couponCreate = actions.payload;
      state.isLoading = false;
    },
    setCouponExport(state, actions) {
      state.couponExport = actions.payload;
      state.isExportLoading = false;
    },
  },
});
export const {
  setCouponList,
  setCouponDetails,
  setCouponCreate,
  setCouponExport,
} = couponsSlice.actions;
const couponsReducer = couponsSlice.reducer;
export default couponsReducer;
